import React from "react";
import Learn from "../../component/learn/index";

export function Learns() {
  return <Learn />;
}
